import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import './index.css';
import { Link } from 'react-router-dom';

export const SelectButtonComponent = ({
  options = [],
  selected = '',
  pageId = '',
  setSelected,
}: any) => {
  const [isOpen, setIsOpen] = useState(false);

  const selectedOption = options.find((opt: any) => opt.id === selected);
  const otherOptions = options.filter((opt: any) => opt.id !== selected);

  return (
    <div className='sb-switch-cs-button-container'>
      <button
        className='sb-switch-cs-button'
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <div className='sb-in-switch-cs-button'>
          <ChevronDown
            className={`sb-chevron-icon ${isOpen ? 'sb-chevron-open' : ''}`}
          />
          <span>{selectedOption?.label}</span>
          {selectedOption?.icon && (
            <img
              className='sb-switch-button-icon'
              src={selectedOption.icon}
              alt={selectedOption.label}
            />
          )}
        </div>
      </button>

      {isOpen && (
        <div className='sb-select-modal'>
          {otherOptions.map((opt: any) => (
            <Link
              to={`${window.location.origin}/viewers/fleet-sites/${opt.id}/${pageId}`}
              key={opt.id}
            >
              <div
                className='sb-select-option'
                onClick={() => {
                  setSelected(opt.id);
                  setIsOpen(false);
                }}
              >
                <span>{opt.label}</span>
                {opt.icon && (
                  <img
                    className='sb-switch-button-icon'
                    src={opt.icon}
                    alt={opt.label}
                  />
                )}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};
